import { InputV2 } from '@cimplico/components';
import { Controller, useFormContext } from 'react-hook-form';

type DescriptionFieldProps = {
    index: number;
};

function DescriptionField({ index }: DescriptionFieldProps): JSX.Element {
    const { control } = useFormContext();

    return (
        <Controller
            name={`lines.${index}.description`}
            control={control}
            render={({ field: { onChange, value } }): JSX.Element => (
                <InputV2
                    type="text"
                    borderStyle="underline"
                    placeholder="Description..."
                    value={value === null ? '' : value}
                    onChange={onChange}
                />
            )}
        />
    );
}

export default DescriptionField;
